// extracted by mini-css-extract-plugin
export var editButton = "_oa-0";